<template>
  <div class="dial-gauge-wrapper">
    <h1
      v-show="displayValueHeader"
      class="text-center"
    >
      <b>{{ value }}</b>
    </h1>
    <canvas
      id="gauge"
      ref="gauge"
    />
  </div>
</template>

<script>
import { Gauge } from 'gaugeJS';
export default {
  props: {
    value:[Number,String],
    min: Number,
    max: Number,
    displayValueHeader: Boolean,
    // if passing in a options prop, be aware that any of the nested property objects need to be
    // passed in whole. Deep merging isn't handled. Ex: staticLabels needs both font & labels passed in.
    options: {
      type: Object,
      required: false,
      default: ()=>({}),
    }
  },
  data() {
    return {
      gaugeObj:{},
      mergedOpts:{},
      defaultOpts: {
        angle: -0.12, // The span of the gauge arc
        lineWidth: 0.28, // The line thickness
        radiusScale: 1, // Relative radius
        pointer: {
          length: 0.61, // // Relative to gauge radius
          strokeWidth: 0.088, // The thickness
          color: '#000000' // Fill color
        },
        limitMax: false,     // If false, max value increases automatically if value > maxValue
        limitMin: false,     // If true, the min value of the gauge will be fixed
        colorStart: '#e2e2e2',   // Colors
        colorStop: '#6c9f47',    // just experiment with them
        strokeColor: '#EEEEEE',  // to see which ones work best for you
        generateGradient: true,
        highDpiSupport: true,
        staticLabels: {
          font: "10px sans-serif",
          labels: [0, 25, 50, 75, 100],  // Print labels at these values
        },
        staticZones: [
          {strokeStyle: "#F03E3E", min: 0, max: 33},  // Red
          {strokeStyle: "#FFDD00", min: 34, max: 66}, // Yellow
          {strokeStyle: "#6c9f47", min: 67, max: 100}, // Green
        ]
      }
    }
  },
  watch:{
    value: function (newVal,oldVal) {
      this.gaugeObj.set(newVal);
    }
  },
  mounted(){
    Object.assign(this.mergedOpts, this.defaultOpts,this.options);
    this.gaugeObj = new Gauge(this.$el.querySelector('canvas')).setOptions(this.mergedOpts);
    this.gaugeObj.setMinValue(this.min);
    this.gaugeObj.maxValue = this.max;
    this.gaugeObj.set(this.value);
  }
}

</script>
<style lang="scss" scoped>
    .dial-gauge-wrapper{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
</style>
